<div class="wing-container">
    <nts-loader [skipHeader]="false" [isVisible]="wingViewModel.onActionInProgress | async"></nts-loader>
    <div #wingPlaceHolder></div>
</div>
